
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { SyncIndicators } from "./SyncIndicators";

interface SetButtonProps {
  exerciseId: string;
  setIndex: number;
  reps: number;
  weight: number;
  isSyncing: boolean;
  lastSyncTime?: number;
  onClick: () => void;
}

export const SetButton = ({
  exerciseId,
  setIndex,
  reps,
  weight,
  isSyncing,
  lastSyncTime,
  onClick
}: SetButtonProps) => {
  return (
    <Button
      key={`${exerciseId}-set-${setIndex}`}
      onClick={onClick}
      variant="outline"
      className={`h-auto p-4 border-[black]/30 hover:bg-primary/10 hover:border-[black]/10 text-white bg-white/5 transition-all duration-200 flex flex-col items-start gap-2 relative ${
        isSyncing ? 'ring-2 ring-blue-400/50 animate-pulse' : ''
      } ${lastSyncTime && lastSyncTime < 200 ? 'ring-1 ring-green-400/30' : ''}`}
    >
      <div className="flex items-center gap-2 w-full">
        <Edit className="h-4 w-4 text-primary" />
        <span className="font-medium text-primary dark:text-white ocean:text-black forest:text-white ocean:hover:bg-black sunset:text-white">Serie {setIndex + 1}</span>
        <div className="ml-auto flex items-center gap-2">
          <SyncIndicators 
            isSyncing={isSyncing} 
            lastSyncTime={lastSyncTime}
          />
        </div>
      </div>
      
      <div className="text-xs text-primary/70 dark:text-white ocean:text-black forest:text-white ocean:hover:bg-black sunset:text-white w-full text-left">
        <div>{reps} {reps === 1 ? 'rep' : 'reps'}</div>
        <div>{weight} kg</div>
      </div>
      
    </Button>
  );
};
